import React from 'react';

import CN from './UseProductModal.module.scss';

const UseProductModal = ({ title, children, onSave, onCancel, disabled }) => (
  <div data-bem="UseProductModal">
    <div data-bem="UseProductModal_overlay" className={CN.overlay} />
    <div data-bem="UseProductModal_container" className={CN.container}>
      <div className={CN.content}>
        <h3>{title}</h3>
        {children}
      </div>
      <footer data-bem="UseProductModal_footer">
        <button className="btn btn-violet-link" onClick={onCancel}>
          CANCEL
        </button>
        <button className="btn btn-violet" disabled={disabled} onClick={onSave}>
          USE ITEM
        </button>
      </footer>
    </div>
  </div>
);

export default UseProductModal;
